export default __webpack_public_path__ + "static/media/menu.5261053b.svg";